import {
  createBaseQuery,
  createServerSideRequestOption,
  getBaseUrl,
} from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const getAuthUserCompanyInvites = async (request: Request) => {
  return await createServerSideRequestOption({
    url: `${getBaseUrl()}/api/v1/c/invites/my-invites?status=PENDING`,
    request: request,
    method: "GET",
  });
};

export const companyUserApi = createApi({
  reducerPath: "companyUserApi",
  baseQuery: createBaseQuery("/c/users"),
  tagTypes: ["companyUsers", "user-audits"],
  endpoints: (build) => ({
    editCompanyUser: build.mutation<
      CompanyUser,
      { companyId: number; companyUserId: number; data: CompanyUserData }
    >({
      query: ({ companyId, companyUserId, data }) => ({
        url: `/${companyId}/${companyUserId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["companyUsers"],
    }),
    listCompanyUser: build.query<
      CompanyUser[],
      { companyId: number; search: string }
    >({
      query: ({ companyId, search }) => ({
        url: `/${companyId}`,
        method: "GET",
        params: { search },
      }),
      providesTags: ["companyUsers"],
    }),
    listAuditHistories: build.query<
      AuditHistory[],
      { companyId: number; data: AuditFilter }
    >({
      query: ({ companyId, data }) => ({
        url: `/${companyId}/audit-histories`,
        method: "POST",
        body: data,
      }),
      providesTags: ["user-audits"],
    }),
  }),
});
